export const PrimaryColor = '#4f46e5';
